export default __webpack_public_path__ + "static/media/fly-airtaxi-right.ca55febd.svg";